import React from 'react';
import { Card, CardActions, CardContent, CardMedia, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const DonationCard = ({ title, amount, description, image, alt, handleAddToCart, readMoreLink }) => {
    const renderDescription = () => {
        let listStarted = false;
        return (
            <>
                {Array.isArray(description) ? description.map((item, index) => {
                    // If the item ends with a colon/semicolon and the list hasn't started, we keep the text left-aligned
                    if ((/:$|;$/.test(item)) && !listStarted) {
                        listStarted = true;
                        return (
                            <Typography key={`p-${index}`} variant="body2" color="text.secondary" paragraph>
                                {item}
                            </Typography>
                        );
                    }

                    // If the list has started, we render list items with indentation
                    if (listStarted) {
                        return (
                            <Typography key={`li-${index}`} variant="body2" color="text.secondary" component="li" sx={{ pl: 4, listStyleType: 'disc', display: 'list-item' }}>
                                {item}
                            </Typography>
                        );
                    }

                    // Before the list starts, render as paragraphs without indentation
                    return (
                        <Typography key={`p-${index}`} variant="body2" color="text.secondary" paragraph>
                            {item}
                        </Typography>
                    );

                }) : (
                    // If description is not an array, it's rendered as a single paragraph
                    <Typography variant="body2" color="text.secondary" paragraph>
                        {description}
                    </Typography>
                )}
            </>
        );
    };

    return (
        <Card sx={{
            maxWidth: 345,
            m: 2,
            border: '1px solid rgba(0, 0, 0, 0.12)',
            borderRadius: '1rem',
            boxShadow: 3,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            ':hover': {
                boxShadow: 6,
                transform: 'scale(1.02)',
                transition: 'transform 0.7s ease, box-shadow 0.7s ease',
            },
        }}>
            <CardMedia
                component="img"
                image={image}
                alt={alt}
                sx={{
                    height: 220,
                    objectFit: 'cover',
                }}
            />
            <CardContent sx={{
                flexGrow: 1,
                '& ul': { padding: 0 }, // Removes padding from ul created by MUI
                pb: 0,
                mb: 0 
            }}>
                <Typography gutterBottom variant="h5" component="div">
                    {title}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    <strong>Amount: {amount}</strong>
                </Typography>
                {renderDescription()}
            </CardContent>
            <CardActions sx={{
                justifyContent: 'space-between',
                p: 2,
                pt: 0, // Reduce padding on the top of CardActions
                pb: 2, // Optional: Adjust bottom padding if needed
            }}>
                <Button size="small" variant="contained" color="primary" sx={{
                    borderRadius: 8,
                    transition: 'background-color 0.3s ease',
                    ':hover': {
                        backgroundColor: '#f39c12',
                        color: 'white',
                    },
                }} onClick={handleAddToCart}>
                    Add to Cart
                </Button>
                {readMoreLink && (
                    <Link to={readMoreLink} style={{ textDecoration: 'none' }}>
                        <Button size="small" variant="contained" color="secondary" sx={{
                            borderRadius: 8,
                            transition: 'background-color 0.3s ease',
                            ':hover': {
                                backgroundColor: '#f39c12',
                                color: 'white',
                            },
                        }}>
                            Read More
                        </Button>
                    </Link>
                )}
            </CardActions>
        </Card>
    );
};

export default DonationCard;
